import { Module } from 'vuex';
import account, { AccountState } from './account';
import prize, { PrizeState } from './prize';
import coin, { CoinState } from './coin';
import { RootState } from '@/types/store';

export interface WalletState {
    account: AccountState;
    coin: CoinState;
    prize: PrizeState;
}

const m: Module<WalletState, RootState> = {
    namespaced: true,
    modules: {
        account,
        coin,
        prize,
    },
};

export default m;
